import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../AuthService";
import { all_routes } from "../../router/all_routes";

function useAuth() {
  const navigation = useNavigate();
  const routes = all_routes;

  const token = localStorage.getItem("LoginToken")


  const signIn = async (loginForm, otp) => {
    try {
      const resp = await login(loginForm, otp);
      console.log("useAuth1111",resp);
      if (resp?.data?.token) {
        localStorage.setItem("LoginToken", resp?.data?.token);
        return resp;
      } else {
        return resp;
      }
    } catch (error) {
      console.log("loginError: ", error);
      return { Success: false, Error: error.message || "Login failed" };
    }
  }

  const signOut = () => {
    if (token) {
      localStorage.removeItem("LoginToken");
      localStorage.clear();
      navigation(routes.login);
    }
  }

  return { signIn, signOut };
}

export default useAuth;